
import React, { Component } from 'react';
import {
    withStyles,
    WithStyles,
    Card,
    CardContent,
    CardActions,
    Checkbox,
    Typography,
    Modal,
    CardHeader,
    IconButton,
    Button,
    Grid,
    FormControl,
    FormControlLabel,
    FormGroup,
    Radio,
    Icon,
    RadioGroup,
} from '@material-ui/core'
import { getFormattedDates } from '../../treeComponents/helper/GetFormattedDates';
import color from '@material-ui/core/colors/amber';

interface MoveChapterProps {
    treeData: any,
    onSelection: Function
}

interface MoveChapterState {
    selectedWeek: {
        phase: string,
        week: string
    };
    selectedTab:string;

}

class MoveChapter extends Component<
    MoveChapterProps,
    MoveChapterState
>{
    constructor(props: MoveChapterProps){
        super(props);
        this.state = {
            selectedWeek: {
                phase: '',
                week: ''
            },
          selectedTab:'',
        }
    }

    handleRadio = (event:any, phaseNumber:any, weekNumber:any) => {
        const { name, value } = event.target;
        const { onSelection } = this.props;
        console.log('handleRadio',{phase: phaseNumber, week: weekNumber})
        this.setState({selectedTab:phaseNumber+'-'+weekNumber})
        onSelection({
            phase: phaseNumber,
            week: weekNumber
        })
    }

    render = () => {
        const { treeData} = this.props;
        const{selectedTab}=this.state;
        let { phases,displaySettings } = treeData;
        const {showPhases,showWeeks,showChapters,showConcepts}=displaySettings;
        let weekIndexNumber = 0;
        phases = phases.filter((phase: any) => !phase.isRevision);
        // Update to show only non revision phase in pop-up
        const phaseFields =
         showWeeks? phases.map((phase:any, phaseNumber:number) => {
            const { weeks } = phase;
            const phaseField = <Grid container style={{borderBottom: '1px solid #e5e5e5',padding: '15px'
            }} key={phaseNumber}>
                <Typography style={{fontSize: '16px', fontWeight: 600}}>
                    {`Phase ${phaseNumber + 1}`}
                </Typography>
            </Grid>
            const weekFields =(
                <RadioGroup style={{width: '100%'}} name="destinationWeek" value={selectedTab}>
             {showWeeks && weeks.map((week:any, weekNumber: number) => {
                weekIndexNumber++;
                const { subjects } = week;
                let numberOfConcepts = 0;
                subjects.forEach((subject:any) => {
                    const { chapters } = subject;
                    chapters.forEach((chapter:any) => {
                        const { concepts } = chapter;
                        numberOfConcepts += concepts.length;
                    })
                })

                return <Grid container style={{borderBottom: '1px solid #e5e5e5',
                padding: '10px 15px 20px',}} key={weekNumber}>
                    <Grid item>
                            <FormControlLabel
                                // classes={{ root: classes.labelText }}
                                // className={classes.marginTopMD}
                                control={
                                    <Radio
                                    color="primary"
                                    onChange={(event) =>
                                        this.handleRadio(event, phaseNumber, weekNumber)
                                    }
                                    value={phaseNumber+'-'+weekNumber}
                                    checked={selectedTab===phaseNumber+'-'+weekNumber}
                                    key={phaseNumber+'-'+weekNumber}
                                    />
                                }
                                label={`Week${weekIndexNumber} . ${getFormattedDates(week.startDate, week.endDate)}`}
                            />
                            <Typography style={{fontSize: '14px',fontWeight: 400,paddingLeft: '30px', color: '#666',lineHeight: '12px'}}>
                            {`${numberOfConcepts} Concepts` }
                            </Typography>
                    </Grid>

                </Grid>
             })}
            </RadioGroup>); 
            return <Grid container style={{borderBottom: '1px solid #e5e5e5'
            }} >
                { phaseField } 
                { weekFields } 
                </Grid>
        }) : <RadioGroup style={{width: '100%'}} name="destinationPhase" value={selectedTab}>
               {phases.map((phase:any, phaseNumber:number) => {
                return <Grid container style={{borderBottom: '1px solid #e5e5e5',
                padding: '10px 15px 20px',}} key={phaseNumber}>
                    <Grid item>
                            <FormControlLabel
                                // classes={{ root: classes.labelText }}
                                // className={classes.marginTopMD}
                                control={
                                    <Radio
                                    color="primary"
                                    onChange={(event) =>
                                        this.handleRadio(event, phaseNumber,0)
                                    }
                                    value={phaseNumber}
                                    checked={selectedTab===`${phaseNumber}-0`}
                                    key={phaseNumber}
                                    />
                                }
                                label={`Phase-${phaseNumber+1}`}
                            />
                            <Typography style={{fontSize: '14px',fontWeight: 400,paddingLeft: '30px', color: '#666',lineHeight: '12px'}}>
                            </Typography>
                    </Grid>

                </Grid>
              })}
            </RadioGroup>

        return <FormGroup style={{border: '2px solid #e5e5e5',
        margin: '-10px'}}>{phaseFields}</FormGroup>;
    }

}

export default MoveChapter